import Glide from '@glidejs/glide'
//import { updateFadeSlider } from './slider-utils';


const initOfficesBlock = () => {
    let block = document.querySelector(".js-block-offices");

    if (!block) return;
    let gliderRoot = block.querySelector(".glide");
    if (!gliderRoot) return;


    let options = {
        type: 'carousel',
        perView: 6,
        autoplay: 3000,
        animationDuration: 900,
        pauseOnHover: true,
        swipeThreshold: 40, //default 80, which is a bit too lazy
        dragThreshold: 60, //default 120, which is a bit too lazy
        touchAngle: 30,
        gap: 55,
        breakpoints: {
            1024: {
                autoplay: false,
                gap: 35,
                perView: 2,
                peek: { before: 35, after: 120 }
            },
            800: {
                gap: 35,
                perView: 1,
                peek: { before: 35, after: 266 }
            },
            640: {
                gap: 20,
                perView: 1,
                peek: { before: 20, after: 200 }
            },
            500: {
                gap: 20,
                perView: 1,
                peek: { before: 20, after: 80 }
            }
        }


    }

    const glide = new Glide(gliderRoot, options);


    glide.on('mount.after', function () {
        gliderRoot.classList.add('mounted')
    })

    glide.on('run', (event) => {

        //console.log(event);
        //console.log(glide.index);
        //updateNumbers(glide.index);
        //updateBar(glide.index);
        //updateFaces(glide.index);
        //updateTexts(glide.index);
        //updateButtons(glide.index);

    })

    glide.mount()

}

export { initOfficesBlock }
